import Vue from 'vue'
import Router from 'vue-router'

// 解决路由重复导航报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 导入页面组件

Vue.use(Router)

export default new Router({
  mode: 'hash', // 使用 HTML5 hash history 模式，需要后端配置支持
  base: '/',
  routes: [

    {
      path: '/', // 子路由的默认路径（当父路径匹配且没有更具体的子路径时）
      name: 'material',
      component: () => import('../views/web/material.vue'),
    },
    {
      path: '/materialList', // 子路由的默认路径（当父路径匹配且没有更具体的子路径时）
      name: 'materialList',
      component: () => import('../views/admin/materialList.vue'),
    },
    {
      path: '/materialAdd', // 子路由的默认路径（当父路径匹配且没有更具体的子路径时）
      name: 'materialAdd',
      component: () => import('../views/admin/materialAdd.vue'),
    },
    {
      path: '/categoryAdd', // 子路由的默认路径（当父路径匹配且没有更具体的子路径时）
      name: 'categoryAdd',
      component: () => import('../views/admin/categoryAdd.vue'),
    },
     {
      path: '/materialAdd_copy', // 子路由的默认路径（当父路径匹配且没有更具体的子路径时）
      name: 'materialAdd_copy',
      component: () => import('../views/admin/materialAdd copy.vue'),
    },
    {
      path: '/login', // 子路由的默认路径（当父路径匹配且没有更具体的子路径时）
      name: 'login',
      component: () => import('../views/admin/login.vue'),
    },
    // 404 页面
    {
      path: '*',
      name: 'NotFound',
      component: () => import('../views/NotFound.vue'), // 懒加载
      meta: { requireAuth: false }
    }

  ]
})
